function isSafariLowerThan13() {
  if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    return +navigator.userAgent.match(/version\/(\d+)/i)?.[1] < 13;
  }
  return false;
}

export default isSafariLowerThan13;
